{
	"content": {
		"declarationDetailsSection": {
			"title": "Detalles de la declaración",
			"description": "Para crear la declaración se necesita el nombre del cliente, la dirección y el país del titular de la declaración. La información no se puede cambiar posteriormente.",
			"customerLabel": "Cuenta de cliente"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Proporcionar detalles de la declaración",
			"alertDescription": "La información que proporcione quedará registrada permanentemente en la declaración y no podrá modificarse posteriormente.",
			"projectLabel": "Referencia del proyecto",
			"companyNameLabel": "Nombre de empresa",
			"streetLabel": "Calle",
			"zipCodeLabel": "Código postal",
			"cityLabel": "Ciudad",
			"countryLabel": "País"
		}
	},
	"summary": {
		"title": "Resumen",
		"declarationTypeTitle": "Tipo de declaración",
		"customerProjectTitle": "Proyecto de cliente",
		"internalProjectOrProductTitle": "Proyecto/producto interno",
		"projectReferenceTitle": "Referencia del proyecto",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantidad ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Reducciones de carbono asignables ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Reducción de carbono no asignable ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Se requiere referencia del proyecto",
		"companyNameRequired": "El nombre de la empresa es obligatorio.",
		"streetRequired": "Se requiere calle",
		"zipCodeRequired": "Se requiere código postal",
		"cityRequired": "Se requiere ciudad",
		"countryRequired": "Se requiere país",
		"customerRequired": "Se requiere cliente"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Revisar resumen de la declaración",
		"description": "Revise los datos que ha ingresado para detectar errores.",
		"alertDescription": "La información que haya proporcionado quedará registrada permanentemente en la declaración y no podrá modificarse posteriormente.",
		"typeSectionTitle": "1. Tipo",
		"declarationTypeLabel": "Tipo de declaración",
		"customerProjectTitle": "Proyecto de cliente",
		"internalProjectOrProductTitle": "Proyecto/producto interno",
		"projectReferenceLabel": "Referencia del proyecto",
		"materialSectionTitle": "2. Material",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantidad ({{unit}})",
		"totalCarbonReductionsLabel": "Reducciones totales de carbono ({{unit}})",
		"declarationSectionTitle": "3. Declaración",
		"companyNameLabel": "Nombre de empresa",
		"streetLabel": "Calle",
		"zipCodeLabel": "Código postal",
		"cityLabel": "Ciudad",
		"countryLabel": "País",
		"backTitle": "Atrás",
		"submitTitle": "Sí, todo es correcto"
	},
	"submitTitle": "Crear declaración",
	"backTitle": "Atrás"
}
